import { Axios } from './../shared/Axios';
import qs from 'qs';

class NotificationService extends Axios {

    private static instance: NotificationService;

    static get(): NotificationService {
        if (!NotificationService.instance) {
            NotificationService.instance = new NotificationService();
        }
        return NotificationService.instance;
    }

    async getNotifications(data: object): Promise<any> {
        return this.instance.get(`/admin/notification${qs.stringify(data, { addQueryPrefix: true })}`)
    }

    async saveNotification(data: object): Promise<any> {
        return this.instance.post(`/admin/notification`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }


    async deleteNotification(id: number): Promise<any> {
        return this.instance.delete(`/admin/notification/${id}`)
    }

    async getMembers(data: any, options: any): Promise<any> {
        return this.instance.get(`/admin/notification/members${qs.stringify(data, { addQueryPrefix: true })}`, options)
    }


}


const notificationService = NotificationService.get();

export { notificationService as NotificationService }